import React, { FC } from 'react'

import { Column } from '../../../components'

import { FeaturesDetailsBlockOption } from '../features-details-block-option'

import { ProductAttributeProps } from './product-attributes.types'
import { useStyle } from './product-attributes.styles'

export const ProductAttributes: FC<ProductAttributeProps> = ({
  className = '',
  id,
  attributes
}) => {
  const classes = useStyle()

  return (
    <Column
      alignItems="flex-start"
      justifyContent="flex-start"
      fullWidth
      className={className}
    >
      {attributes &&
        attributes.map((attr) => (
          <FeaturesDetailsBlockOption
            key={`product_${id}_material_${attr.id}`}
            className={classes.optionsRow}
            label={`${attr.attribute.title}:`}
            text={attr.type || '-'}
          />
        ))}
    </Column>
  )
}
